import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../common/Breadcrumbs/Breadcrumbs";
import MuiGrid from "../../common/DataGrid/MuiGrid";
import {
	DateRangePicker,
} from "@mui/x-date-pickers-pro";
import {
	collection,
	doc,
	getCountFromServer,
	getDocs,
	orderBy,
	query,
	Timestamp,
	where,
} from "firebase/firestore";

import orderby from "lodash.sortby";
import { DateTime } from "luxon";
import { auth, db } from "../../scripts/app";
import "../../css/grid.module.css";
import * as cardClasses from "../../common/Cards/cardStyles.module.css";
// import * as classes from "../../css/task-dashboard.module.css";
import * as statsClasses from "../../css/stats-dashboards.module.css";
import BarChart from "../../common/DataGrid/BarChart";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { presets } from "../../common/consts/DateRangePresets";
import { Button, CircularProgress } from "@mui/material";
import { useNavigate, useParams, replace } from "react-router-dom";
import noResults from "url:../../images/no-results-light.png"


let lowestTasks = Number.MAX_SAFE_INTEGER;
let highestTasks = 0;
let allowedWorkflows = [];

export default function CategoryStats() {

	const today = [
		DateTime.now().startOf("day"),
		DateTime.now().endOf("day"),
	];

	const { tsstartDate, tsendDate, categoryID } = useParams();
	const [subjectAggregates, setSubjectAggregates] = useState({});
	const [subjectCardData, setSubjectCardData] = useState([]);
	const [subjects, setSubjects] = useState([]);
	const [categories, setCategories] = useState([]);
	const [tableData, setTableData] = useState([]);
	const [chartData, setChartData] = useState([]);
	const [dateRange, setDateRange] = useState(tsstartDate && tsendDate ? [DateTime.fromMillis(Number(tsstartDate)), DateTime.fromMillis(Number(tsendDate))] : today);
	const [selectedCategory, setSelectedCategory] = useState("Select Category");
	const [totalSubjects, setTotalSubjects] = useState(0);
	const [results, setResults] = useState(false);
	const [workflowsUsed, setWorkflowsUsed] = useState(0);
	const [loading, setLoading] = useState(false);
	const nav = useNavigate()

	const gridColumns = [
		{
			field: selectedCategory?.name ?? "category",
			headerName: selectedCategory?.name ?? "Category",

			flex: 1,
		},
		{
			field: "workflowName",
			headerName: "Workflow Completed",
			rowSpanValueGetter: () => null,

			flex: 1,
		},
		{
			field: "tasksCompleted",
			headerName: "Completed Task Count",
			rowSpanValueGetter: () => null,

			flex: 1,
		},
		{
			field: "view",
			headerName: "Workflow Results",
			rowSpanValueGetter: () => null,
			align: "right",
			width:128,
			renderCell: (args) => {
				return (
					<Button variant='contained' onClick={() => {
						replace(args.value[1]);
						nav(args.value[0]);
					}}
						sx={{
							color: 'white',
							borderRadius: '3rem',
							backgroundColor: '#562EA6',
							'&:hover': {
								backgroundColor: '#2d1069',
							},
						}}
					>
						View
					</Button>
				);
			},

			flex: 1,
		},
	];

	const CategorySelectInput = ({ categories, selectedCategory }) => {
		let sortedCategories = orderby(categories, "name");
		const getValue = () => {
			if (selectedCategory === "Select Category") {
				return ("");
			} else {
				return (selectedCategory?.id);
			};
		}
		return (
			<Box>
				<FormControl fullWidth sx={{ minWidth: "300px" }}>
					<InputLabel id="category-select-label" value={""}>Select Category</InputLabel>
					<Select
						labelId="category-select-label"
						id="category-select"
						label="Select Category"
						value={getValue()}
						onChange={(e) => {
							const selected = categories.find(
								(cat) => cat.id === e.target.value
							);
							console.log('selected category on change > ', selected)
							setSelectedCategory(selected);
						}}
					>
						{sortedCategories.map((category) => (
							<MenuItem value={category.id} key={category.id}>
								{category.name}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</Box>
		);
	};

	useEffect(() => {
		let ignore = false;
		window.scrollTo(0, 0)
		async function getCategories() {
			const queryCategories = query(
				collection(db, "categories"),
				orderBy("name", "asc")
			);
			const queryCategoriesSnapshot = await getDocs(queryCategories);
			queryCategoriesSnapshot.forEach((doc) => {
				if (!ignore && !doc.data().hideFromAggregates) {
					setCategories((categories) => [
						...categories,
						{
							name: doc.data().name,
							id: doc.id,
						},
					]);
				}
			});
			}

			getCategories().catch((error) => console.error("Error getting categories: ", error))
			return () => {
				ignore = true;
			};
	}, []);

	useEffect(() => {
		setSelectedCategory(() => {
			const selected = categories.find((cat) => cat.id === categoryID);
			if (categoryID && selected) {
				return selected;
			} else {
				return "Select Category";
			}
		})
	}, [categories, categoryID])

	useEffect(() => {
		setSubjectAggregates({});
		setSubjects([]);
		setTableData([]);
		setChartData([]);
		setSubjectCardData([]);
		setResults(false);
		setWorkflowsUsed(0);
		setTotalSubjects(0);
	}, [selectedCategory]);
	async function getSubjectAggregates() {
		if (!selectedCategory?.id) return;
		setSubjectAggregates({});
		setSubjects([]);
		setTableData([]);
		setChartData([]);
		setSubjectCardData([]);
		setResults(false);
		setWorkflowsUsed(0);
		setTotalSubjects(0);
		allowedWorkflows = [];
		const querySubjectAggregates = query(
			collection(db, "subjectAggregates"),
			where("date", ">=", Timestamp.fromMillis(dateRange[0].ts)),
			where("date", "<=", Timestamp.fromMillis(dateRange[1].ts))
		);
		const querySubjectAggregatesSnapshot = await getDocs(
			querySubjectAggregates
		);
		const categoriesRef = doc(db, "categories", selectedCategory.id);
		const subjectsRef = collection(categoriesRef, "subjects");
		const snapshot = await getCountFromServer(subjectsRef);
		const subjectsSnapshot = await getDocs(subjectsRef);

		setTotalSubjects(snapshot.data().count);
		const token = await auth.currentUser.getIdTokenResult();
		const securityTags = token?.claims.securityTags;
		const queryWorkflowsUntagged = query(collection(db, "workflows"), where("hasSecurityTags", "==", false))
		const queryWorkflowsTagged = Array.isArray(securityTags) && securityTags.length > 0 ? query(collection(db, "workflows"), where('securityTags', 'array-contains-any', securityTags)) : undefined


		const workflowsCollectionUntagged = await getDocs(queryWorkflowsUntagged);
	  	const workflowsCollectionTagged = queryWorkflowsTagged ? await getDocs(queryWorkflowsTagged): undefined;

		workflowsCollectionUntagged.forEach((doc) => {
		allowedWorkflows = [...allowedWorkflows, doc.id]
		})
		workflowsCollectionTagged?.forEach((doc) => {
		allowedWorkflows = [...allowedWorkflows, doc.id]
		})

			subjectsSnapshot.forEach((doc) => {
				setSubjects((subjects) => [...subjects, { ...doc.data(), id: doc.data().id ?? doc.id }]);
			});

			querySubjectAggregatesSnapshot.forEach((doc) => {
				const aggregateCategories = doc.data().categories ?? {};
				let selectedCategoryData =
					aggregateCategories[selectedCategory.id] ?? undefined;
				if (selectedCategoryData?.subjects) {
					Object.keys(selectedCategoryData.subjects).forEach((subjectKey) => {
						let subject = selectedCategoryData.subjects[subjectKey];
						Object.keys(subject.workflows ?? {}).forEach((workflowKey) => {
							let workflow = subject.workflows[workflowKey];
							let taskCount = Object.keys(workflow.tasks ?? {}).length;
							let rowId = `${workflowKey}-${subjectKey}`;
							setSubjectAggregates((subjectAggregates) => {
								if (subjectAggregates[rowId]) {
									return ({
										...subjectAggregates,
										[rowId]: {
											[selectedCategory.name]: subject.name ?? subjectKey,
											workflowName: workflow.name ?? workflowKey,
											tasksCompleted:
												taskCount +
												subjectAggregates[rowId]
													.tasksCompleted,
											workflowId: workflowKey,
											id: rowId,
											view: [`/main/launchpad/task-results/${workflowKey}/category-stats/${dateRange[0].ts}/${dateRange[1].ts}/${subjectKey}`,
											`/main/launchpad/category-stats/${selectedCategory.id}/${dateRange[0].ts}/${dateRange[1].ts}`],
										},
								})
							} else {
									return ({
										...subjectAggregates,
										[rowId]: {
											[selectedCategory.name]: subject.name ?? subjectKey,
											workflowName: workflow.name ?? workflowKey,
											tasksCompleted: taskCount,
											id: rowId,
											workflowId: workflowKey,
											view: [`/main/launchpad/task-results/${workflowKey}/category-stats/${dateRange[0].ts}/${dateRange[1].ts}/${subjectKey}`,
											`/main/launchpad/category-stats/${selectedCategory.id}/${dateRange[0].ts}/${dateRange[1].ts}`],
									},
								})
							}
						}
						);
					});
				});
			}
		});
		if (typeof selectedCategory !== 'string') {
			history.replaceState(null, null, `/main/launchpad/category-stats/${selectedCategory?.id}/${dateRange[0]?.ts}/${dateRange[1]?.ts}`)
		}
	}

	useEffect(() => {
		if (typeof selectedCategory === "string") {
			setResults(false);
			setTableData([]);
			setSubjectCardData([]);
			setWorkflowsUsed(0);
			return;
		}

		const allowedSubjectAggregates = Object.values(subjectAggregates).filter((item) => allowedWorkflows.includes(item.workflowId));

		setResults(allowedSubjectAggregates.length > 0);
		setTableData(allowedSubjectAggregates);
		setWorkflowsUsed(new Set(allowedSubjectAggregates.map((subject) => subject.workflowId)).size);

		setSubjectCardData([]);

		allowedSubjectAggregates.forEach((subject) => {
			setSubjectCardData((subjectCardData) => {
				let alreadyExists = false;
				let newData = subjectCardData.map((card) => {
					if (card.label === subject[selectedCategory.name]) {
						alreadyExists = true;
						return {
							...card,
							workflowsUsed: card.workflowsUsed + 1,
							tasksCompleted: card.tasksCompleted + subject.tasksCompleted,
						};
					}
					return card;
				});

				if (!alreadyExists) {
					return [
						...subjectCardData,
						{
							label: subject[selectedCategory.name],
							workflowsUsed: 1,
							tasksCompleted: subject.tasksCompleted,
							id: subject.id,
							rank: "unranked",
						},
					];
				} else {
					return newData;
				}
			});
		});

		subjects.forEach((subject) => {
			setSubjectCardData((cards) => {
				if (!contains(cards, subject.name, "label")) {
					return [
						...cards,
						{
							label: subject.name,
							workflowsUsed: 0,
							tasksCompleted: 0,
							id: subject.id,
							rank: "unranked",
						},
					];
				}
				return [...cards];
			});
		});
	}, [subjectAggregates, subjects, selectedCategory]);

	useEffect(() => {
		setChartData([]);
		tableData.forEach((item) => {
			setChartData((chartData) => {
				if (contains(chartData, item[selectedCategory.name], "label")) {
					let newChartData = chartData.map((chartItem) => {
						if (chartItem.label === item[selectedCategory.name]) {
							return {
								...chartItem,
								value: chartItem.value + item.tasksCompleted,
							};
						} else {
							return chartItem;
						}
					});
					return newChartData;
				} else {
					return [
						...chartData,
						{
							label: item[selectedCategory.name],
							id: item.id,
							value: item.tasksCompleted,
						},
					];
				}
			});
		});
	}, [tableData]);

	const getMostLeastActive = (data) => {
		highestTasks = 0;
		lowestTasks = Number.MAX_SAFE_INTEGER;
		data.map((item) => {
			if (subjectCardData?.length >= 0) {
				if (item.tasksCompleted > highestTasks) {
					highestTasks = item.tasksCompleted;
				}
				if (
					item.tasksCompleted < lowestTasks &&
					item.tasksCompleted !== 0
				) {
					lowestTasks = item.tasksCompleted;
				}
			}
		});
	};

	const getSumField = (data, field) => {
		let count = 0;
		data.forEach((item) => {
			count += item[field];
		});
		return count;
	};

	const contains = (data, valueToCompare, fieldToCheck) => {
		let doesContain = false;
		let indexOfValue = 0;
		data.forEach((item, index) => {
			if (item[fieldToCheck] === valueToCompare) {
				doesContain = true;
				indexOfValue = index;
			}
		});
		return doesContain;
	};

	const orderCards = (data) => {
		let orderedData = orderby(data, "label", "asc");
		return orderedData;
	};

	return (
		<>
			<Breadcrumbs
				breadcrumbs={[
					{ name: "Launchpad", href: "/main/launchpad" },
					{
						name: "Category Stats",
						href: "/main/launchpad/category-stats",
						current: true,
					},
				]}
			/>
			<main className="flex flex-col align-middle">

				<section className="bg-[#d8d2e7] p-2 flex flex-col justify-start h-96 items-center">
					<h1 className="text-[#4c4c4c]">Category Usage Stats</h1>
					<p className="text-[#4c4c4c] text-center w-[26rem] md:w-[40rem] ">Select a category used as a Workflow Primary Subject (assets, places or people)</p>
				</section>

				<div className="mt-[-14rem] md:mt-[-15rem] mx-3">
					<section className={`flex flex-col md:flex-row flex-wrap lg:flex-nowrap gap-4 shadow-lg justify-start mb-2 w-[unset] sm:mx-1 md:mx-2 lg:mx-4 bg-white rounded-xl overflow-hidden p-4 px-6  border-l-[12px] border-l-[#492298] items-center`}>
						<CategorySelectInput categories={categories} selectedCategory={selectedCategory} />
							<DateRangePicker
								sx={{ minWidth: 300 }}
								value={dateRange}
								onChange={(range) => range?.[0] && range?.[1] && setDateRange(range)}
								label="Date Range"
								timezone="system"
							slotProps={{
								shortcuts: { items: presets },
							}}
							/>
							<Button variant='contained' disabled={!selectedCategory?.id || loading} onClick={() => {
									setLoading(true)
									getSubjectAggregates()
										.catch((error) => console.error("Error getting category stats: ", error))
										.finally(() => setLoading(false))
								}} className="text-white rounded-3xl bg-[#562EA6] h-fit px-[1.1rem] py-[0.45rem] hover:bg-[#2d1069]">
							Search
						</Button>
						{loading && <CircularProgress size="30px" sx={{color: "#562EA6"}}/>}
					</section>

					<ul className={`${cardClasses.cards} ${cardClasses.aggregateCards} ${statsClasses.aggregateCards}`}>
						<li className={`${cardClasses.card} ${cardClasses.aggregateCard} ${statsClasses.aggregateCard}`}>
							<div className={cardClasses.upper}>
								<h2>Active Subjects</h2>
								<div className="flex-wrapper stats-area">
									<div className={cardClasses.stat}>
										{chartData.length}
										<span className={cardClasses.ofStat}>
											of {totalSubjects}
										</span>
									</div>
									<div className={cardClasses.metric}>
										category: {selectedCategory?.name ?? "Please select"}
									</div>
								</div>
							</div>
						</li>

						<li className={`${cardClasses.card} ${cardClasses.aggregateCard} ${statsClasses.aggregateCard}`}>
							<div className={cardClasses.upper}>
								<h2>INACTIVE SUBJECTS</h2>
								<div className="flex-wrapper stats-area">
									<div className={cardClasses.stat}>
										{totalSubjects - chartData.length}
									</div>
								</div>
								<div className={cardClasses.metric}>
									category: {selectedCategory?.name ?? "Please select"}
								</div>
							</div>
						</li>

						<li className={`${cardClasses.card} ${cardClasses.aggregateCard} ${statsClasses.aggregateCard}`}>
								<div className={cardClasses.upper}>
									<h2>Workflows Used</h2>
									<div className="flex-wrapper stats-area">
										<div className={cardClasses.stat}>{workflowsUsed}</div>
										<div className={cardClasses.metric}>WORKFLOWS</div>
									</div>
								</div>
						</li>

						<li className={`${cardClasses.card} ${cardClasses.aggregateCard}  ${statsClasses.aggregateCard}`}>
							<div className={cardClasses.upper}>
								<h2>TASKS COMPLETED</h2>
								<div className="flex-wrapper stats-area">
									<div className={cardClasses.stat}>
										{getSumField(tableData, "tasksCompleted")}
									</div>
									<div className={cardClasses.metric}>TASKS</div>
								</div>
							</div>
						</li>

					</ul>
					{!results ? (
						<div className="bg-white mx-3 rounded-xl shadow-lg flex flex-col justify-center items-center">
							<img
								width="300px"
								// src="../../images/no-results-light.png"
								src={noResults}
								alt="no results"
							/>
							<p className="mb-4 text-lg text-wrap text-center px-4">There were no results during this time period! Try changing Category or date range.</p>
							<p className="mb-10 text-lg bg-slate-200 rounded-3xl p-3 px-8">
								{dateRange[0]?.toLocaleString() ?? '-'} to{" "}
								{dateRange[1]?.toLocaleString() ?? '-'}
							</p>
						</div>
					) : (
						<div className="flex flex-col lg:flex-row gap-2 justify-between sm:mx-1 md:mx-2 lg:mx-4">
							<section className="bg-white rounded-xl overflow-hidden p-3 shadow-lg grow">
								<MuiGrid
									data={tableData}
									columns={gridColumns}
									slotProps={{
										toolbar: {
										  csvOptions: {
											fileName: `category-stats-${selectedCategory?.name}-${dateRange[0]?.toLocaleString()}-${dateRange[1]?.toLocaleString()}`,
										  },
										},
									  }}
									initialState={{
										sorting: {
											sortModel: [
												{ field: selectedCategory.name, sort: "asc" },
											],
										},
									}}
								/>
							</section>

							<aside className={`${cardClasses.barchartArea}`}>

								<h2 className="p-2 px-0 pb-4 font-semibold">
									Total tasks complete by:{" "}
									<span className="font-bold">{selectedCategory.name}</span>
								</h2>

								<BarChart data={chartData} percentage ordered color={"#492298"} backgroundColor={"#49229850"} />
							</aside>
						</div>
					)}

					<section className="flex flex-row flex-wrap my-3 sm:mx-1 md:mx-2 lg:mx-4 mb-2">
						{getMostLeastActive(subjectCardData)}
						<ul className={`${cardClasses.cards} ${cardClasses.subjectCards}`}>
							{orderCards(subjectCardData).map((item, index) => {
								let status = "";
								if (item.tasksCompleted == 0) {
									status = cardClasses.inactive;
								}

								return (
									<li
										className={`${cardClasses.card} ${cardClasses.subjectCard} ${status}`}
										key={item.id}
									>
										<h3>{item.label}</h3>

										{item.tasksCompleted === lowestTasks && results && (
											<div className={`${cardClasses.ribbon} `}>
												<div className="absolute top-0 right-0 h-1 ">
													<div className="relative overflow-hidden w-[190px] h-32 top-[-5px] right-[-28px]">
														<div className={`${cardClasses.ribbonValue} ${cardClasses.leastActive}`}>
															Least Active
														</div>
													</div>
												</div>
											</div>
										)}
										{item.tasksCompleted === highestTasks && results && (
											<div className={`${cardClasses.ribbon}`}>
												<div className="absolute top-0 right-0 h-1 ">
													<div className="relative overflow-hidden w-[190px] h-32 top-[-5px] right-[-28px]">
														<div
															className={`${cardClasses.ribbonValue} ${cardClasses.mostActive}`}
														>
															Most Active
														</div>
													</div>
												</div>
											</div>
										)}
										<div className={`${cardClasses.lowerStats} `}>
											<p className={`${cardClasses.inactiveMessage} pb-2`}>
												{status == ""
													? `Tasks Completed: ${item.tasksCompleted}`
													: "INACTIVE"}
											</p>
											<p className={`pb-2`}>Workflows Used:{item.workflowsUsed}</p>
										</div>
									</li>
								);
							})}
						</ul>
					</section>
				</div>
			</main>
		</>
	);
}
